<!-- Profile Edit Component - Triggers email verification modal only -->
<!-- No visible UI to prevent PII exposure -->
 <ng-container></ng-container>